export default function throwIfNullOrUndefined<T>(
  input: T | null | undefined,
  paramName: string
): T {
  if (input != null && input !== undefined) {
    return input;
  }
  throw new Error(`Expected ${paramName} not to be null or undefined`);
}
